<template>
  <GestionProveedores />
</template>
<script>
import GestionProveedores from "./components/GestionProveedores";
export default {
  components: { GestionProveedores },
};
</script>
